<div class="rule-page">

  <div class="rule-page__intro">
    <h1 class="stk-page-title">Raktár szabály</h1>
    <div class="stk-page-sub">A rendszer az eladási átlagból számol minimum készletszintet, és ha egy termék fogytán van, automatikusan hosszabb feladási határidőre vált — így sosem csúszol ki a vállalt szállításból.</div>
  </div>

  <!-- 1 · Alapszint kalkuláció -->
  <div class="rule-card">
    <div class="rule-card__head">
      <span class="rule-card__num">1</span>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19 V5"></path><path d="M4 19 H20"></path><polyline points="7,14 11,10 14,13 19,7"></polyline></svg>
      <h3 class="rule-card__title">Alapszint kalkuláció</h3>
      <span class="rule-card__hint">eladási átlag alapján</span>
      <div class="rule-toggle-wrap">
        <span class="rule-toggle-wrap__label">{{ config.ruleEnabled ? 'Bekapcsolva' : 'Kikapcsolva' }}</span>
        <div class="rule-toggle" [class.rule-toggle--on]="config.ruleEnabled" (click)="toggleRule()">
          <span class="rule-toggle__knob"></span>
        </div>
      </div>
    </div>
    <div class="rule-card__body">
      <div class="rule-question">Hány hónap eladási átlagát vegye figyelembe?</div>
      <div class="rule-chip-row rule-chip-row--lookback">
        <button
          *ngFor="let months of lookbackOptions"
          type="button"
          class="rule-chip"
          [class.rule-chip--active]="config.lookbackMonths === months"
          (click)="setLookback(months)"
        >{{ months }} hónap</button>
      </div>
      <div class="rule-question rule-question--tight">Alapszint = a havi átlag ekkora hányada</div>
      <div class="rule-question-sub">Pl. 50% = fél havi átlagfogyás legyen a minimum szint.</div>
      <div class="rule-chip-row rule-chip-row--factor">
        <button
          *ngFor="let factor of factorOptions"
          type="button"
          class="rule-chip"
          [class.rule-chip--active]="isFactorActive(factor)"
          (click)="setFactor(factor)"
        >{{ factorLabel(factor) }}</button>
      </div>
      <div class="stk-info-bar" *ngIf="exampleText">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5C7A2E" stroke-width="2" stroke-linecap="round" class="stk-info-bar__icon"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="11" x2="12" y2="16.5"></line><circle cx="12" cy="7.8" r="0.5" fill="#5C7A2E"></circle></svg>
        <span>{{ exampleText }}</span>
      </div>

      <!-- A szabály magától is fut naponta; ez a gomb azonnal átszámol. -->
      <div class="rule-actions">
        <button type="button" class="rule-action-btn" [disabled]="recalculating" (click)="recalculateNow()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12 a8 8 0 1 1 -2.3 -5.6"></path><polyline points="20,4 20,9 15,9"></polyline></svg>
          {{ recalculating ? 'Számolás…' : 'Újraszámolás most' }}
        </button>
        <span class="rule-actions__note" *ngIf="config.lastAppliedAt">
          Utoljára lefutott: {{ config.lastAppliedAt | date:'yyyy. MM. dd. HH:mm' }}
        </span>
        <span class="rule-actions__note" *ngIf="!config.lastAppliedAt">Még nem futott le.</span>
      </div>
    </div>
  </div>

  <!-- 2 · Feladási osztályok -->
  <div class="rule-card">
    <div class="rule-card__head">
      <span class="rule-card__num">2</span>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12,7 12,12 15.5,14"></polyline></svg>
      <h3 class="rule-card__title">Feladási osztályok</h3>
      <span class="rule-card__hint">Etsy feldolgozási idő profilok</span>
    </div>
    <div class="dispatch-grid dispatch-grid--head">
      <div class="dispatch-grid__label">Osztály neve</div>
      <div class="dispatch-grid__label dispatch-grid__label--right">Min. nap</div>
      <div class="dispatch-grid__label dispatch-grid__label--right">Max. nap</div>
      <div class="dispatch-grid__label">Határidő</div>
      <div class="dispatch-grid__label">Etsy szállítási profil</div>
      <div></div>
    </div>
    <div class="dispatch-grid" *ngFor="let dispatchClass of config.dispatchClasses; trackBy: trackDispatchClass">
      <input class="dispatch-grid__name" [value]="dispatchClass.name" (change)="onClassNameChange(dispatchClass, $event)">
      <input class="dispatch-grid__num" [value]="dispatchClass.minDays" (change)="onClassMinChange(dispatchClass, $event)">
      <input class="dispatch-grid__num" [value]="dispatchClass.maxDays" (change)="onClassMaxChange(dispatchClass, $event)">
      <span class="dispatch-grid__days">{{ daysLabel(dispatchClass) }}</span>
      <!-- Boltonként külön profil: az Etsy szállítási profil azonosítója
           BOLTHOZ kötött, a másik bolt profilját visszautasítaná. -->
      <div class="dispatch-grid__profiles">
        <div class="dispatch-profile" *ngFor="let assignment of dispatchClass.etsyProfiles">
          <span class="dispatch-profile__shop">{{ assignment.shopName }}</span>
          <select class="dispatch-grid__profile" [value]="assignment.shippingProfileId || ''"
                  (change)="onClassProfileChange(dispatchClass, assignment, $event)">
            <option value="" [selected]="!assignment.shippingProfileId">Nincs hozzárendelve</option>
            <!-- A már beállított, de az Etsy-ről most le nem kérdezett profil se
                 tűnjön el a legördülőből (különben mentéskor kiürülne). -->
            <option *ngIf="assignment.shippingProfileId && !profilesForShop(assignment.shopId).length"
                    [value]="assignment.shippingProfileId" [selected]="true">Profil #{{ assignment.shippingProfileId }}</option>
            <option *ngFor="let profile of profilesForShop(assignment.shopId)" [value]="profile.id"
                    [selected]="profile.id === assignment.shippingProfileId">{{ profileLabel(profile) }}</option>
          </select>
        </div>
        <div class="dispatch-profile__empty" *ngIf="!dispatchClass.etsyProfiles?.length">
          Nincs bekötött Etsy bolt.
        </div>
      </div>
      <button type="button" class="dispatch-grid__remove" title="Törlés" (click)="removeDispatchClass(dispatchClass)">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
      </button>
    </div>
    <div class="dispatch-empty" *ngIf="!config.dispatchClasses.length">Még nincs feladási osztály — vedd fel az elsőt.</div>
    <button type="button" class="dispatch-add" (click)="addDispatchClass()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
      Új feladási osztály
    </button>

    <!-- Etsy szinkron. A feladási időt az Etsy-n a SZÁLLÍTÁSI PROFIL hordozza
         (az árakkal együtt), ezért a profilokat ott hozzuk létre, és az ERP
         csak átkapcsolja rájuk a listákat. -->
    <div class="etsy-sync">
      <div class="etsy-sync__head">
        <div>
          <div class="etsy-sync__title">Kiküldés az Etsy-re</div>
          <div class="etsy-sync__desc">
            A feladási osztályhoz rendelt szállítási profilra állítja az érintett listákat.
            A profilokat az Etsy felületén hozd létre (ott van rajtuk az árazás és a régiók).
          </div>
        </div>
        <div class="rule-toggle-wrap">
          <span class="rule-toggle-wrap__label">{{ config.etsySyncEnabled ? 'Bekapcsolva' : 'Kikapcsolva' }}</span>
          <div class="rule-toggle" [class.rule-toggle--on]="config.etsySyncEnabled" (click)="toggleEtsySync()">
            <span class="rule-toggle__knob"></span>
          </div>
        </div>
      </div>
      <div class="etsy-sync__actions">
        <button type="button" class="rule-action-btn" [disabled]="etsyProfilesLoading" (click)="fetchEtsyProfiles()">
          {{ etsyProfilesLoading ? 'Profilok betöltése…' : 'Profilok frissítése' }}
        </button>
        <button type="button" class="rule-action-btn" [disabled]="syncingEtsy || !config.etsySyncEnabled" (click)="syncEtsyNow()">
          {{ syncingEtsy ? 'Kiküldés…' : 'Kiküldés most' }}
        </button>
      </div>
      <div class="etsy-sync__error" *ngIf="etsyProfilesError">{{ etsyProfilesError }}</div>
    </div>
  </div>

  <!-- 3 · Automatikus feladási szabály -->
  <div class="rule-card">
    <div class="rule-card__head">
      <span class="rule-card__num">3</span>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 L20 6.5 V12 C20 16.6 16.6 19.8 12 21 C7.4 19.8 4 16.6 4 12 V6.5 Z"></path><polyline points="9,12 11.3,14.3 15.5,9.3"></polyline></svg>
      <h3 class="rule-card__title">Automatikus feladási szabály</h3>
      <div class="rule-toggle-wrap">
        <span class="rule-toggle-wrap__label">{{ config.autoAssignEnabled ? 'Bekapcsolva' : 'Kikapcsolva' }}</span>
        <div class="rule-toggle" [class.rule-toggle--on]="config.autoAssignEnabled" (click)="toggleAuto()">
          <span class="rule-toggle__knob"></span>
        </div>
      </div>
    </div>
    <div class="rule-card__body rule-card__body--tiers">
      <div class="tier-intro">Ha egy termék készlete csökken, a rendszer a listázás feldolgozási idejét automatikusan az itt megadott osztályra állítja — és visszaáll, amint újra feltöltöd.</div>
      <div class="tier-row" *ngFor="let tier of tierRows">
        <div>
          <span class="tier-chip" [ngClass]="'tier-chip--' + tier.tone" [class.tier-chip--dim]="!config.autoAssignEnabled">
            <span class="tier-chip__dot"></span>{{ tier.chipLabel }}
          </span>
          <div class="tier-row__desc">{{ tier.desc }}</div>
        </div>
        <div class="tier-row__arrow">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="19" y2="12"></line><polyline points="14,7 19,12 14,17"></polyline></svg>
        </div>
        <div class="tier-row__select">
          <select [value]="tierClassId(tier.key)" (change)="onTierChange(tier.key, $event)">
            <option *ngIf="!config.dispatchClasses.length" value="">—</option>
            <option *ngFor="let dispatchClass of config.dispatchClasses" [value]="dispatchClass.id" [selected]="dispatchClass.id === tierClassId(tier.key)">{{ classOptionLabel(dispatchClass) }}</option>
          </select>
          <div class="tier-row__chevron">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 4 · Élő előnézet -->
  <div class="rule-card rule-card--last">
    <div class="rule-card__head">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="16" y1="16" x2="21" y2="21"></line></svg>
      <h3 class="rule-card__title">Élő előnézet</h3>
      <span class="rule-card__hint">a mostani készlet + beállítások alapján</span>
    </div>
    <div class="preview-scroll">
      <div class="preview-grid preview-grid--head">
        <div class="preview-grid__label">Termék</div>
        <div class="preview-grid__label preview-grid__label--right">Havi átlag</div>
        <div class="preview-grid__label preview-grid__label--right">Automatikus</div>
        <div class="preview-grid__label preview-grid__label--right">Kézi</div>
        <div class="preview-grid__label preview-grid__label--right">Mérvadó</div>
        <div class="preview-grid__label preview-grid__label--right">Elérhető</div>
        <div class="preview-grid__label">Állapot</div>
        <div class="preview-grid__label">Aktív feladás</div>
      </div>
      <div class="preview-grid" *ngFor="let row of previewRows; trackBy: trackPreviewRow">
        <div class="preview-grid__product">
          <div class="preview-grid__name">{{ row.name }}</div>
          <div class="preview-grid__meta">
            <span class="preview-grid__shop" *ngIf="row.shop" [style.background]="shopBadgeColor(row.shop)">{{ row.shop }}</span>
            <span class="preview-grid__sku">{{ row.sku }}</span>
          </div>
        </div>
        <div class="preview-grid__avg" data-label="Átlag/hó" [title]="row.noHistory ? '' : (row.totalSold || 0) + ' db / ' + (row.effectiveMonths || 0) + ' hónap'">{{ row.noHistory ? '—' : avgLabel(row) + ' db' }}</div>

        <!-- Automatikus szint. Ha nincs elég előzmény, itt látszik, mennyi van. -->
        <div class="preview-grid__level" data-label="Autom." [class.is-active]="row.source === 'auto'">
          <ng-container *ngIf="row.autoLevel !== null">{{ row.autoLevel }} db</ng-container>
          <span class="preview-nohistory" *ngIf="row.autoLevel === null"
                [title]="'Csak ' + (row.historyDays || 0) + ' nap eladási előzmény — a számításhoz legalább 30 nap kell, addig a kézi minimum a mérvadó.'">
            Nincs adat<br>{{ row.historyDays || 0 }}/30 nap
          </span>
        </div>

        <!-- Kézi szint: mindig látszik, akkor is, ha épp nem ez a mérvadó. -->
        <div class="preview-grid__level" data-label="Kézi" [class.is-active]="row.source === 'manual'">{{ row.manualLevel }} db</div>

        <div class="preview-grid__strong" data-label="Mérvadó">
          {{ row.minLevel }} db
          <span class="preview-source" [ngClass]="'preview-source--' + row.source">{{ sourceLabel(row.source) }}</span>
        </div>
        <div class="preview-grid__strong" data-label="Elérhető">{{ row.available }} db</div>
        <div class="preview-grid__state"><span class="preview-state" [ngClass]="'preview-state--' + row.state">{{ stateLabel(row.state) }}</span></div>
        <div class="preview-grid__active" data-label="Aktív feladás"><span class="preview-class" [ngClass]="'preview-class--' + row.state">{{ activeClassName(row) }} · {{ activeClassDays(row) }}</span></div>
      </div>
      <div class="preview-empty" *ngIf="!previewRows.length && !previewLoading">
        {{ previewUnavailable ? 'Az élő előnézet még nem érhető el — a kalkulációt a szerver számolja majd.' : 'Nincs megjeleníthető termék.' }}
      </div>
      <div class="preview-empty" *ngIf="previewLoading">Betöltés…</div>
    </div>
    <div class="preview-note">
      Az „elérhető" a kész készlet és a komponensekből még összeállítható darabszám összege.
      A „mérvadó" oszlop mondja meg, hogy most az automatikus vagy a kézi szint van érvényben:
      30 napnál rövidebb eladási előzménynél mindig a kézi.
    </div>
  </div>

  <!-- 5 · Komponens szintek -->
  <div class="rule-card rule-card--last">
    <div class="rule-card__head">
      <span class="rule-card__num">5</span>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 L20 7.5 V16.5 L12 21 L4 16.5 V7.5 Z"></path><polyline points="4,7.5 12,12 20,7.5"></polyline><line x1="12" y1="12" x2="12" y2="21"></line></svg>
      <h3 class="rule-card__title">Komponens szintek</h3>
      <span class="rule-card__hint">a termékek igényéből visszaszámolva</span>
      <input class="comp-search" [(ngModel)]="componentSearch" [ngModelOptions]="{ standalone: true }"
             placeholder="Keresés név vagy SKU szerint…">
    </div>
    <div class="preview-scroll">
      <div class="comp-grid comp-grid--head">
        <div class="preview-grid__label">Komponens</div>
        <div class="preview-grid__label preview-grid__label--right">Automatikus</div>
        <div class="preview-grid__label preview-grid__label--right">Kézi</div>
        <div class="preview-grid__label preview-grid__label--right">Mérvadó</div>
        <div class="preview-grid__label preview-grid__label--right">Elérhető</div>
        <div class="preview-grid__label">Állapot</div>
        <div class="preview-grid__label">Feladási szabály</div>
      </div>
      <div class="comp-grid" *ngFor="let row of visibleComponentRows; trackBy: trackComponentRow">
        <div class="preview-grid__product">
          <div class="preview-grid__name">{{ row.name }}</div>
          <div class="preview-grid__meta">
            <span class="preview-grid__sku">{{ row.sku }}</span>
            <span class="comp-usage" *ngIf="row.usedInProducts">{{ row.usedInProducts }} termékben</span>
          </div>
        </div>
        <div class="preview-grid__level" data-label="Autom." [class.is-active]="row.source === 'auto'">
          <ng-container *ngIf="row.autoLevel !== null">{{ row.autoLevel }} db</ng-container>
          <span class="preview-nohistory" *ngIf="row.autoLevel === null"
                title="Ez a komponens egyetlen termék BOM-jában sem szerepel, ezért nincs miből visszaszámolni — a kézi minimum a mérvadó.">
            Nincs adat
          </span>
        </div>
        <div class="preview-grid__level" data-label="Kézi" [class.is-active]="row.source === 'manual'">
          <input class="comp-manual" type="text" [value]="row.manualLevel"
                 (change)="onComponentManualLimitChange(row, $event)">
        </div>
        <div class="preview-grid__strong" data-label="Mérvadó">
          {{ row.effectiveLevel }} db
          <span class="preview-source" [ngClass]="'preview-source--' + row.source">{{ sourceLabel(row.source) }}</span>
        </div>
        <div class="preview-grid__strong" data-label="Elérhető">{{ row.available }} db</div>
        <div class="preview-grid__state"><span class="preview-state" [ngClass]="'preview-state--' + row.state">{{ stateLabel(row.state) }}</span></div>
        <div class="comp-exempt" data-label="Feladási szabály">
          <div class="rule-toggle rule-toggle--sm" [class.rule-toggle--on]="!row.dispatchRuleExempt"
               [title]="row.dispatchRuleExempt ? 'Kivéve: ez a komponens nem befolyásolja a feladási időt.' : 'Érvényes: ha ez a komponens elfogy, a termék feladási ideje hosszabbra vált.'"
               (click)="toggleComponentExempt(row)">
            <span class="rule-toggle__knob"></span>
          </div>
          <span class="comp-exempt__label">{{ row.dispatchRuleExempt ? 'Kivéve' : 'Érvényes' }}</span>
        </div>
      </div>
      <div class="preview-empty" *ngIf="!visibleComponentRows.length && !componentsLoading">Nincs megjeleníthető komponens.</div>
      <div class="preview-empty" *ngIf="componentsLoading">Betöltés…</div>
    </div>
    <div class="preview-note">
      A komponens automatikus szintje a termékek mérvadó minimumából és a BOM darabszámokból jön
      (szülő minimum × beépülő mennyiség, minden felhasználásra összegezve).
      A „Feladási szabály" kapcsolóval kivehető egy alkatrész: a mindig raktáron lévő csomagolóanyag
      így nem húzza le a termékek feladási idejét.
    </div>
  </div>

</div>
